import type { ReactNode } from 'react';

export interface LoadingProps {
  tip?: ReactNode;
  inline?: boolean;
}

export function Loading({ tip = '加载中…', inline = false }: LoadingProps) {
  const wrapperStyle: React.CSSProperties = inline
    ? { display: 'inline-flex', alignItems: 'center', gap: 8 }
    : {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 32,
        gap: 12,
        color: '#595959',
      };

  return (
    <div role="status" aria-live="polite" style={wrapperStyle}>
      <span
        aria-hidden
        style={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          border: '2px solid #d9d9d9',
          borderTopColor: '#1677ff',
          animation: 'mall-shared-spin 0.8s linear infinite',
          display: 'inline-block',
        }}
      />
      {tip ? <span style={{ fontSize: 13 }}>{tip}</span> : null}
      <style>
        {`@keyframes mall-shared-spin { from { transform: rotate(0); } to { transform: rotate(360deg); } }`}
      </style>
    </div>
  );
}
